/******/
(() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsAjaxCart = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

      if (isScreenSizeLarge() || this.cart_action == 'drawer') {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == 'drawer') {

        this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

        $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();

          return false;
        });

      } else if (this.cart_action == 'mini_cart') {
        this.showMiniCartOnHover();
      }

      $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

        return false;
      });

      $(document).on('click', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        Shopify.theme.jsAjaxCart.removeFromCart(lineID);

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.removeFromCart(lineID);
        }

        return false;
      });

      $(document).on('click', '[data-ajax-cart-close]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();

        return false;
      });
      $(document).on('click', ".ajax_recommend_add", function () {
        let id = $(this).attr("data-id");
        if (id != null) {
          Shopify.theme.jsAjaxCart.recommendedAddToCart(id, $(this));
        }
      })
    },
    showMiniCartOnHover: function () {
      const $el = $('[data-ajax-cart-trigger]');

      $el.hover(function () {
        if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
          $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
        } else {
          $el.addClass('show-mini-cart');
        }
      }, function () {
        $el.removeClass('show-mini-cart');
      });
    },
    hideMiniCart: function () {
      if (this.cart_action != 'mini_cart') return false;
      const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
      $el.removeClass('show-mini-cart');
    },
    toggleMiniCart: function () {
      const $el = $('.mobile-header [data-ajax-cart-trigger]');

      // Removes url to the cart page so user is not redirected
      $el.attr('href', '#');

      $el.off('touchstart').on('touchstart', function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest('[data-ajax-cart-mini_cart]')) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass('show-mini-cart');
      });
    },
    showDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.addClass('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
      document.documentElement.classList.add('no-scroll');
      this.updateSwatchesQuantity();
      const $recommendedslider = $("#recommended-products .recommended-products-wrap");
      if ($recommendedslider.hasClass('flickity-enabled')) {
        $recommendedslider.flickity('destroy');
      }
      $recommendedslider.flickity({
        wrapAround: false,
        initialIndex: 1,
        prevNextButtons: true,
        pageDots: true
      });
      $recommendedslider.on('settle.flickity', function () {
        $recommendedslider.flickity('resize');
        console.log("resize");
      });
    },
    hideDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      document.documentElement.classList.remove('no-scroll');
      this.ajaxCartDrawer.removeClass('is-visible');
      $('.ajax-cart__overlay').removeClass('is-visible');
      $('.ajax-submit').removeClass('pplr_adding');
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {
          Shopify.theme.jsAjaxCart.updateView();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

        }
      });
    },
    initializeAjaxCart: function () {

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({html, options}) => {

          $('[data-ajax-cart-content]').html(html.content);

          // Converting the currencies
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }

        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {

      this.toggleMiniCart();

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({html, options}) => {

          $('.mobile-header [data-ajax-cart-content]').html(html.content);

        })
        .fail(() => {
          // some error handling
        });
    },
    recommendedAddToCart: function ($id, $btn) {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {
          "id": $id,
          "quantity": 1
        },
        beforeSend: function () {
          $btn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $btn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = (response.message) ? response.message : response.description;

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();

          $btn.parent()
            .find('.cart-warning')
            .html(cartWarning);

          $btn
            .removeAttr('disabled')
            .removeClass('disabled');

          $btn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $btn
            .find('span:not(.icon)')
            .text($btn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    },
    maxQuantity: 5,
    currentQuantity: 0,
    showEventModal: function () {
      if (!localStorage.getItem('isEvent') && !localStorage.getItem('onlyShop')) {
        showModal(document.getElementById('event-question'));
      }
    },
    updateCartNotice: function () {
      let cartNotice = $('.ajax-cart__form .tmg-cart-notice');
      let cartNoticeText = $('.ajax-cart__form .tmg-cart-notice-text');
      if (this.currentQuantity === this.maxQuantity) {
        cartNotice.addClass('full');
      } else {
        cartNotice.removeClass('full');
      }
      cartNotice.show();
      cartNoticeText.html(`You have used ${this.currentQuantity} of ${this.maxQuantity} free swatches.`);
    },
    disabledAddToCart: async function () {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const checkoutBtn = $('.ajax-cart__button.button--add-to-cart.button');
      const fitQuizBtn = $('.ajax-cart__button-wrapper .fitQuizCartBtn');

      const isSuit = cart.items.some(item => item.product_type === 'Suit' || item.product_type === 'Tuxedo');
      if (!localStorage.getItem('isFitQuiz') && isSuit) {
        localStorage.getItem('cartHasSuit')
        checkoutBtn.attr('disabled', 'disabled');
        fitQuizBtn.addClass('active')
      } else {
        localStorage.removeItem('cartHasSuit')
        checkoutBtn.removeAttr('disabled');
        fitQuizBtn.removeClass('active')
      }
    },
    updateSwatchesQuantity: function () {
      return $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: (cart) => {
          let swatchesQuantity = 0;

          cart.items.forEach(item => {
            if (item.product_type === 'Swatches') {
              swatchesQuantity += item.quantity;
            }
          });

          this.currentQuantity = swatchesQuantity;
          if (swatchesQuantity > 0) {
            this.updateCartNotice();
          } else {
            this.removeCartNotice();
          }
        },
        error: function (error) {
          console.error('Error fetching cart data:', error);
        }
      });
    },
    removeCartNotice: function () {
      $('.tmg-cart-notice').hide();
    },
    checkSwatchesProductQuantity: async function (newProductUrl, newQuantity) {
      try {
        const productResponse = await fetch(window.Shopify.routes.root + newProductUrl);
        const product = await productResponse.json();
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        let swatchesQuantity = 0;
        let isProductInCart = false;

        cart.items.forEach(item => {
          if (item.product_type === 'Swatches') {
            swatchesQuantity += item.quantity;
            if (item.handle === product.handle) {
              isProductInCart = true;
            }
          }
        });
        // console.log(product)

        if (isProductInCart) {
          notice('This product is already in the cart.', 'info');
          Shopify.theme.jsAjaxCart.showDrawer();
          return false;
        }

        if (product.type === 'Swatches') {
          this.showEventModal(); // if customer don't have event, show event modal

          if ((swatchesQuantity + newQuantity) > Shopify.theme.jsAjaxCart.maxQuantity) {
            popupCart('cart', 'Free Swatches', `You can add up to <strong>${Shopify.theme.jsAjaxCart.maxQuantity}</strong> free swatches.`).openPopup();
            // Shopify.theme.jsAjaxCart.showDrawer();
            return false;
          }
        }
        return true;
      } catch (error) {
        console.error('Error checking product quantity:', error);
        return false;
      }
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

      $addToCartForm.removeClass('shopify-product-form--unselected-error');

      if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

        $('.warning').remove();

        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning);

        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      } else {
        const formData = new FormData($addToCartForm[0]);
        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const productUrl = $addToCartForm.find('[product-url]').attr('product-url').replace(/^\//, '');

        this.checkSwatchesProductQuantity(productUrl, quantity)
          .then(isValid => {
            if (isValid) {
              $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: $addToCartForm.serialize(),
                beforeSend: function () {
                  $addToCartBtn
                    .attr('disabled', 'disabled')
                    .addClass('disabled');

                  $addToCartBtn.find('span')
                    .removeClass("fadeInDown")
                    .addClass('animated zoomOut');
                },
                success: function (product) {
                  Shopify.theme.jsAjaxCart.currentQuantity += quantity;

                  let $el = $('[data-ajax-cart-trigger]');

                  $addToCartBtn
                    .find('.checkmark')
                    .addClass('checkmark-active');

                  function addedToCart() {
                    if (!isScreenSizeLarge()) {
                      $el = $('.mobile-header [data-ajax-cart-trigger]');
                      Shopify.theme.scrollToTop($el);
                    } else {
                      $el = $('[data-ajax-cart-trigger]');
                    }

                    $el.addClass('show-mini-cart');

                    $addToCartBtn.find('span')
                      .removeClass('fadeInDown');
                  }

                  window.setTimeout(function () {
                    $addToCartBtn
                      .removeAttr('disabled')
                      .removeClass('disabled');

                    $addToCartBtn.find('.checkmark')
                      .removeClass('checkmark-active');

                    $addToCartBtn.find('.text, .icon')
                      .removeClass('zoomOut')
                      .addClass('fadeInDown');

                    $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
                  }, 1000);

                  Shopify.theme.jsAjaxCart.showDrawer();
                  Shopify.theme.jsAjaxCart.updateView();

                  if (Shopify.theme.jsCart) {
                    $.ajax({
                      dataType: "json",
                      async: false,
                      cache: false,
                      dataType: 'html',
                      url: "/cart",
                      success: function (html) {
                        const cartForm = $(html).find('.cart__form');
                        $('.cart__form').replaceWith(cartForm);
                      }
                    });
                  }
                },
                error: function (XMLHttpRequest) {
                  let response = eval('(' + XMLHttpRequest.responseText + ')');
                  response = (response.message) ? response.message : response.description;

                  const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

                  $('.warning').remove();

                  $addToCartForm
                    .find('.cart-warning')
                    .html(cartWarning);

                  $addToCartBtn
                    .removeAttr('disabled')
                    .removeClass('disabled');

                  $addToCartBtn.find('.icon')
                    .removeClass('zoomOut')
                    .addClass('zoomIn');

                  $addToCartBtn
                    .find('span:not(.icon)')
                    .text($addToCartBtn.data('label'))
                    .removeClass('zoomOut')
                    .addClass('zoomIn');
                }
              });
            }
          })
          .catch(error => {
            console.error('Error during quantity check:', error);
          });
      }
    },
    updateView: function () {

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({html, options}) => {

          if (options.item_count > 0) {
            const itemList = $(html.content).find('.ajax-cart__list');
            const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
            const total_price = options.total_price

            $('.ajax-cart__list').replaceWith(itemList);
            $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
            $('.ajax-cart__empty-cart-message').addClass('is-hidden');
            $('.ajax-cart__form').removeClass('is-hidden');
            $('[data-ajax-cart-trigger]').addClass('has-cart-count');
            $('[data-bind="itemCount"]').text(options.item_count);

            /* Update shipping indicator asynchronously js */
            if ($('[data-fs-threshold]').length) {
              let $parent = $('[data-fs-threshold]')
              let $remainingWrapper = $parent.find('.fs-indicator__remaining')
              let $successWrapper = $parent.find('.fs-indicator__success')

              let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');
              if (fs_threshold >= total_price) {
                //udpate
                let fs_remaining = fs_threshold - total_price;
                let fs_remaining_percent = total_price / fs_threshold * 100

                $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%')
                $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining))

                $remainingWrapper.removeClass('is-hidden')
                $successWrapper.addClass('is-hidden')
              } else {
                //remove shipping indicator
                $remainingWrapper.addClass('is-hidden')
                $successWrapper.removeClass('is-hidden')
              }
            }

            this.updateSwatchesQuantity();
            this.disabledAddToCart();

          } else {
            $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
            $('.ajax-cart__form').addClass('is-hidden');
            $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
            $('[data-bind="itemCount"]').text('0');
          }

          const $recommendedslider = $("#recommended-products .recommended-products-wrap");
          if ($recommendedslider.hasClass('flickity-enabled')) {
            $recommendedslider.flickity('destroy');
          }
          $recommendedslider.flickity({
            wrapAround: false,
            initialIndex: 1,
            prevNextButtons: true,
            pageDots: true
          });
          $recommendedslider.on('settle.flickity', function () {
            $recommendedslider.flickity('resize');
            console.log("resize");
          });

          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    unload: function ($section) {

      // Clear event listeners in theme editor
      $('.ajax-submit').off();
      $('[data-ajax-cart-delete]').off();
    }
  }

  /******/
})()
;